import { CursorWidget } from "./cursor-widget";
export class CursorWidgetController {
    constructor(editor) {
        this._editor = editor;
        this._tooltipDuration = 1000;
        this._cursors = new Map();
    }
    addCursor(clientId, range, userColor, userName) {
        const cursorWidget = new CursorWidget({
            codeEditor: this._editor,
            widgetId: clientId,
            color: userColor,
            range,
            label: userName || clientId.toString(),
            tooltipDuration: this._tooltipDuration,
            onDisposed: () => {
                this.removeCursor(clientId);
            },
        });
        this._cursors.set(clientId, cursorWidget);
    }
    removeCursor(clientId) {
        const cursorWidget = this._cursors.get(clientId);
        if (!cursorWidget) {
            return;
        }
        cursorWidget.dispose();
        this._cursors.delete(clientId);
    }
    updateCursor(clientId, range, userColor, userName) {
        const cursorWidget = this._cursors.get(clientId);
        if (cursorWidget) {
            cursorWidget.updatePosition(range);
            cursorWidget.updateContent(userName);
            return;
        }
        this.addCursor(clientId, range, userColor, userName);
    }
    dispose() {
        this._cursors.forEach((cursorWidget) => cursorWidget.dispose());
        this._cursors.clear();
    }
}
